import type { ReactNode } from 'react'
import realMachinesLogo from '@/assets/branding/real-maquinas-logo-transparent.png'

interface EmptyStateProps {
  title: string
  description: string
  action?: ReactNode
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <section className="empty-state">
      <img className="empty-state__icon" src={realMachinesLogo} alt="" width="1636" height="1252" />
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </section>
  )
}
